<tg-icon
    *ngIf="tmIconType === 'basic-tick'"
    name="basic-tick"
    role="presentation"
>
</tg-icon>
<tg-icon
    *ngIf="tmIconType === 'basic-arrow-right'"
    name="basic-arrow-right"
    role="presentation"
>
</tg-icon>
